import React, { useState, useEffect, useRef } from "react";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Parent of a Student",
    role: "Parent",
    image: "/assets/images/parent1.jpg",
    rating: 5,
    message:
      "The school provides a wonderful learning environment. The teachers are supportive, and the focus on academics as well as extracurricular activities helps children grow with confidence.",
  },
  {
    name: "Parent of a Student",
    role: "Parent",
    image: "/assets/images/parent2.jpg",
    rating: 5,
    message:
      "We appreciate the dedication of the teachers and the school's efforts towards the overall development of students. The activities and learning opportunities are excellent.",
  },
  {
    name: "Parent of a Student",
    role: "Parent",
    image: "/assets/images/parent3.jpg",
    rating: 5,
    message:
      "A positive and disciplined atmosphere where children get opportunities to learn, explore their interests, and develop important life skills.",
  },
  {
    name: "Parent of a Student",
    role: "Parent",
    image: "/assets/images/parent4.jpg",
    rating: 5,
    message:
      "The school encourages students to participate in sports, cultural events, and academic activities. We are happy with the care and guidance provided to our child.",
  },
];

const Testimonials = () => {
  const sliderRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  const scrollTestimonials = (direction) => {
    const slider = sliderRef.current;
    if (!slider) return;

    const card = slider.querySelector(".testimonial-card");
    if (!card) return;

    const gap = parseFloat(
      window.getComputedStyle(slider).columnGap
    ) || 24;

    const amount = card.offsetWidth + gap;
    const maxScroll = slider.scrollWidth - slider.clientWidth;

    if (direction === 1 && slider.scrollLeft >= maxScroll - 5) {
      slider.scrollTo({ left: 0, behavior: "smooth" });
      return;
    }

    if (direction === -1 && slider.scrollLeft <= 5) {
      slider.scrollTo({ left: maxScroll, behavior: "smooth" });
      return;
    }

    slider.scrollBy({
      left: direction * amount,
      behavior: "smooth",
    });
  };

  // AUTOMATIC SLIDING
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      scrollTestimonials(1);
    }, 4000);

    return () => clearInterval(interval);
  }, [isPaused]);

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="container">

        {/* HEADING */}

        <div className="testimonials-heading">

          <h2>
            What Parents <span>Say About Us</span>
          </h2>

          <p>
            Hear from parents about their experiences with Air Force
            School, Vayu Sena Nagar, Nagpur, and our commitment to
            quality education and overall student development.
          </p>
        </div>

        {/* SLIDER CONTROLS */}

        <div className="testimonial-controls">
          <button
            type="button"
            onClick={() => scrollTestimonials(-1)}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            aria-label="Previous testimonial"
          >
            <i className="bi bi-arrow-left"></i>
          </button>

          <button
            type="button"
            onClick={() => scrollTestimonials(1)}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            aria-label="Next testimonial"
          >
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>

        {/* TESTIMONIAL CARDS */}

        <div className="testimonial-slider-wrapper">
          <div
            className="testimonial-slider"
            ref={sliderRef}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={() => setIsPaused(true)}
            onTouchEnd={() => setIsPaused(false)}
          >
            {testimonials.map((item, index) => (
              <div
                className="testimonial-card"
                key={index}
              >

                <div className="testimonial-card-top">
                  <div className="testimonial-quote-icon">
                    <i className="bi bi-quote"></i>
                  </div>

                  <div className="testimonial-stars">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i className="bi bi-star-fill" key={i}></i>
                    ))}
                  </div>
                </div>

                <p className="testimonial-message">
                  {item.message}
                </p>

                <div className="testimonial-divider"></div>

                <div className="testimonial-author">
                  {/* <img
                    src={item.image}
                    alt={item.name}
                    loading="lazy"
                  /> */}

                  <div>
                    <h4>{item.name}</h4>
                    <span>{item.role}</span>
                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Testimonials;